/** Hours tracked on module-builder nodes (service + laborHours). Not a money total. */

function toHours(value) {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

export function moduleGraphHoursTotal(graph) {
  const nodes = graph?.nodes;
  if (!Array.isArray(nodes) || nodes.length === 0) return 0;

  return nodes.reduce((sum, node) => {
    const data = node?.data && typeof node.data === "object" ? node.data : {};
    const type = node?.type;
    if (type === "service") {
      if (data.enabled === false) return sum;
      return sum + toHours(data.hours);
    }
    if (type === "laborHours") {
      return sum + toHours(data.hours);
    }
    return sum;
  }, 0);
}

/** Own graph + nested package graphs × line quantity (same identity rules as offer totals). */
export function calculationModuleHoursTotal(calculation, visited = new Set()) {
  if (!calculation) return 0;
  const id = calculation.id;
  if (id != null) {
    if (visited.has(id)) return 0;
    visited.add(id);
  }

  let hours = moduleGraphHoursTotal(calculation.module_graph);
  const linked = new Set();
  const items = Array.isArray(calculation.items) ? calculation.items : [];
  items.forEach((item) => {
    const nested = item?.nested_calculation;
    if (!nested) return;
    if (nested.id != null) linked.add(nested.id);
    const qty = Number(item.quantity);
    const multiplier = Number.isFinite(qty) && qty > 0 ? qty : 1;
    hours += calculationModuleHoursTotal(nested, visited) * multiplier;
  });

  const nestedList = Array.isArray(calculation.nested_calculations)
    ? calculation.nested_calculations
    : [];
  nestedList.forEach((nested) => {
    if (nested?.id != null && linked.has(nested.id)) return;
    hours += calculationModuleHoursTotal(nested, visited);
  });

  return hours;
}
